<template>
  <v-menu bottom left transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom content-class="tooltip-dark">
        <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
          <v-btn v-bind="{ ...attrs, ...tipAttrs }" v-on="{ ...on, ...tipOn }" :ripple="false" icon class="notification-btn "
            :color="$vuetify.theme.dark ? 'greenMain' : '#171717'" >
            <v-icon>mdi-bell-outline</v-icon>
            <v-badge color="#FF567F" :content="unreadCount" :value="unreadCount > 0" overlap> </v-badge>
          </v-btn>
        </template>
        <span class="tooltip-text">Client Notifications</span>
      </v-tooltip>
    </template>

    <v-card class="notification-card">
      <v-list>
        <v-list-item class="notification-header">
          <v-list-item-content>
            <v-list-item-title>Notification</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div :class="{ 'notification-scroll': notifications.length > 5 }">
        <v-list three-line :class="$vuetify.theme.dark ? '$blue-darken-1 ' : 'white'">
          <v-list-item-group>
            <div v-for="(notification, index) in notifications" :key="notification.id">
              <v-list-item @click="navigateToPage(notification)">
                <template v-slot:default="{ active }">
                  <v-list-item-icon>
                    <v-icon :color="notification.is_read ? 'ash-lighten-5' : 'teal'">
                      mdi-circle-small
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ notification.notification_details }}</v-list-item-title>
                    <v-list-item-subtitle>{{ moment(notification.created_at).fromNow() }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>

              <v-divider v-if="index < notifications.length - 1" :key="index"></v-divider>
            </div>
          </v-list-item-group>
        </v-list>
      </div>

      <v-card-actions class="mark-all-button" v-if="unreadCount > 0">
        <v-btn block color="teal" text @click="markAllAsRead" class="text-capitalize">
          Mark All as Read
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  NOTIFICATIONS__ACTIONS,
} from "../../store/action-types";
import moment from "moment";

export default {
  data: () => ({
  }),

  computed: {
    ...mapState("notifications", ["notifications"]),

    unreadCount() {
      return this.notifications.length;
    }
  },

  methods: {
    ...mapActions("notifications", [
      NOTIFICATIONS__ACTIONS.NOTIFICATIONS,
      NOTIFICATIONS__ACTIONS.MARK_ALL_AS_READ,
      NOTIFICATIONS__ACTIONS.SET_POLLING_INTERVAL,
      NOTIFICATIONS__ACTIONS.STOP_POLLING_INTERVAL,
      NOTIFICATIONS__ACTIONS.UPDATE
    ]),

    navigateToPage(item) {
      let route = '';

      switch (item.purpose) {
        case "kyc_upload":
          route = "/profile-verify";
          break;
        case "live_account":
          route = "/mt5-accounts?tab=2";
          break;
        case "deposit":
          route = "/wallet";
          break;
        case "withdrawal":
          route = "/wallet";
          break;
        case "register":
          route = "/dashboard";
          break;
        case "internal_transfer":
          route = "/wallet";
          break;
        case "demo_account":
          route = "/mt5-accounts?tab=5";
          break;
        case "manager_account":
          route = "/mt5-accounts?tab=4";
          break;
        case "investor_account":
          route = "/mt5-accounts?tab=3";
          break;
        case "ticket":
          route = "/support";
          break;
        case "ib_request":
          route = "/dashboard";
          break;
        case "contest_account":
          route = "/contest";
          break;
        default:
          console.warn("Unknown notification type:", item.type);
          return;
      }

      this[NOTIFICATIONS__ACTIONS.UPDATE](item.id);

      this.$router.push(route);
    },

    async markAllAsRead() {
      await this[NOTIFICATIONS__ACTIONS.MARK_ALL_AS_READ]();
    }
  },

  created() {
    this[NOTIFICATIONS__ACTIONS.SET_POLLING_INTERVAL]();
  },
  beforeDestroy() {
    this[NOTIFICATIONS__ACTIONS.STOP_POLLING_INTERVAL]();
  }
};
</script>

<style scoped>
.notification-btn {
  position: relative;
}

.notification-card {
  min-width: 300px;
  max-width: 400px;
}

.notification-header {
  position: sticky;
  top: 0;
  background: inherit;
  z-index: 1;
}

.notification-scroll {
  max-height: calc(72px * 5);
  overflow-y: auto;
  scrollbar-width: thin;
}

.mark-all-button {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  position: sticky;
  bottom: 0;
  background: inherit;
  z-index: 1;
}

/* Custom scrollbar styling for webkit browsers */
.notification-scroll::-webkit-scrollbar {
  width: 6px;
}

.notification-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.notification-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.notification-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>